import { Accordion } from "react-bootstrap";

const TermsOfUse = () => {
  return (
    <>
      <Accordion.Body>
        Nothing to see here yet sorry this is just some sample text
      </Accordion.Body>
    </>
  );
};

export default TermsOfUse;
